// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Q9ui","title":"AfterFrontImage_title__13hzp"};